<div class="login" style="overflow: auto">
  <header class="pt-0 pb-0">
    <nav class="exportReportNav">
      <div class="align_left">
        <img class="logo" src="./assets/images/stag_logo.png" alt="logo">
      </div>
      <!-- <div>
        <label class="title heading">
          {{ 'menu.deepdive' | translate }}</label>
      </div> -->
      <div class="align_right">
        <label class="title heading">
          {{currentDate | date:'MMM d, y' }}</label>
      </div>

    </nav>
  </header>
  <div class="row only-bottom-padding">
    <div class="row pl-0 pr-0">
      <div class="col-xs-11">
        <h6 class="headerFontSize">{{ 'cockpitReport.cockpitHeader' | translate }}</h6>
      </div>
      <div id="editor"></div>
      <div class="col-xs-1">
      </div>
    </div>
  </div>
  <div class="card cockpitReportCard marginleft4px" *ngIf="cockpitName == 'elements'">
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <div style="width: 61%;">
            <canvas id="FuctionalEUTpie" width="300" height="150" #FuctionalEUTpie></canvas>
          </div>
        </div>

        <div class="col-md-4">
          <div style="width: 75%;">
            <canvas id="mychartStacked" width="300" height="200" #mychartStacked></canvas>
          </div>
        </div>
        <div class="col-md-4">
          <span>
            <ul class="paddingleft15px">
              <li>{{this.myTasksCompletedPercent}}% of tasks have been completed.</li>
              <li>{{this.nonFunctionalScenarioTatalCount}} out of {{this.scenarios.length}} are non-functional
                scenarios.</li>
            </ul>
          </span>
        </div>

      </div>
    </div>
  </div>
  <div class="card cockpitReportCard marginleft4px" *ngIf="cockpitName == 'design'">
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <div style="width: 61%;">
            <canvas id="ReadynessEUTpie" width="300" height="150" #ReadynessEUTpie></canvas>
          </div>
        </div>

        <div class="col-md-4">
          <div style="width: 61%;">
            <canvas id="ReadynessAttrpie" width="300" height="150" #ReadynessAttrpie></canvas>
          </div>
        </div>
        <div class="col-md-4">
          <span>

            <ul class="paddingleft15px">
              <li>{{this.readyEUTsArray.length}} out of {{this.readyEUTsArray.length + this.notReadyEUTsArray.length}}
                EUTs are ready.</li>
              <li>{{this.readyAttributesArray.length}} out of {{this.readyAttributesArray.length +
                this.notreadyAttributesArray.length}} Attributes are ready.</li>
            </ul>
          </span>
        </div>

      </div>
    </div>
  </div>

  <div class="card cockpitReportCard marginleft4px" *ngIf="cockpitName == 'evaluation'">
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <div style="width: 61%;">
            <canvas id="EvaluvationEUTpie" width="300" height="150" #EvaluvationEUTpie></canvas>
          </div>
        </div>

        <div class="col-md-4">
          <div style="width: 61%;">
            <canvas id="EvaluvationAttrpie" width="300" height="150" #EvaluvationAttrpie></canvas>
          </div>
        </div>
        <div class="col-md-4">
          <span>

            <ul class="paddingleft15px">
              <li>{{this.evalEUTsArray.length}} out of {{this.evalEUTsArray.length + this.notEvalEUTsArray.length}} EUTs
                are evaluated.</li>
              <li>{{this.evalAttriArray.length}} out of {{this.evalAttriArray.length + this.notEvalAttriArray.length}}
                Attributes are evaluated.</li>
            </ul>
          </span>
        </div>

      </div>
    </div>
  </div>
  <div class="row" *ngIf="cockpitName == 'design'" id="sourceData">

    <div class="col-md-12">
      <table class="tableBackgrdClrBlack menuItemsClrWhite">
        <th>
          <tr>
            <td>
              <h6>&nbsp;{{ 'cockpitReport.EUTreadyEval' | translate }}</h6>
            </td>
          </tr>
        </th>
        <tbody>
          <tr *ngFor="let name of readyEUTsArray">
            <td>{{this.getModuleName(name)}} | {{name.eName}}</td>
          </tr>
        </tbody>
      </table>
      <div class="row"></div>
      <table class="tableBackgrdClrBlack menuItemsClrWhite">
        <th>
          <tr>
            <td>
              <h6>&nbsp;{{ 'cockpitReport.EutNotreadyEval' | translate }}</h6>
            </td>
          </tr>
        </th>
        <tbody>
          <tr *ngFor="let name of notReadyEUTsArray">
            <td>{{this.getModuleName(name)}} | {{name.eName}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row" *ngIf="cockpitName == 'design'" id="sourceData">
    <div class="col-md-12">
      <table class="tableBackgrdClrBlack menuItemsClrWhite">
        <th>
          <tr>
            <td>
              <h6>&nbsp;{{ 'cockpitReport.AttributereadyEval' | translate }}</h6>
            </td>
          </tr>
        </th>
        <tbody>
          <tr *ngFor="let name of readyAttributesArray">
            <td>&nbsp;{{name.name}}</td>
          </tr>
        </tbody>
      </table>
      <div class="row"></div>
      <table class="tableBackgrdClrBlack menuItemsClrWhite">
        <th>
          <tr>
            <td>
              <h6>&nbsp;{{ 'cockpitReport.AttributeNOtreadyEval' | translate }}</h6>
            </td>
          </tr>
        </th>
        <tbody>
          <tr *ngFor="let name of notreadyAttributesArray">
            <td>&nbsp;{{name.name}}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
  <div class="row" *ngIf="cockpitName == 'elements'" id="sourceData">



    <span *ngIf="myTasksCompletedArray.length > 0">
      <b>
        <h5>{{ 'cockpitReport.tasksCompleted' | translate }} :-</h5>
      </b>
      <ul *ngFor="let name of myTasksCompletedArray"><b>-- {{getModuleName(name)}} | {{name.entity_desc}}
          ({{name.descs.length}}) </b>
        <li *ngFor="let task of name.descs">{{task}}</li>
      </ul>
    </span>
    <div class="row"></div>
    <span>
      <b>
        <h5>{{ 'cockpitReport.tasksNotCompleted' | translate }} :-</h5>
      </b>

      <ul *ngFor="let name of myTasksNotCompletedArray"><b>-- {{getModuleName(name)}} | {{name.entity_desc}}
          ({{name.descs.length}}) </b>
        <li *ngFor="let task of name.descs">{{task}}</li>
      </ul>
    </span>
    <span *ngIf="myTasksCompletedArray.length == 0 && myTasksNotCompletedArray.length == 0">
      <h6>&nbsp;You don't have any tasks to display</h6>
    </span>


  </div>
  <div class="row" *ngIf="cockpitName == 'outcomes'" id="sourceData">
    <div class="col-md-12">
      <table class="tableBackgrdClrBlack menuItemsClrWhite">
        <th>
          <tr>
            <td>
              <h6>&nbsp;{{ 'cockpitReport.cleanEUT' | translate }}</h6>
            </td>
          </tr>
        </th>
        <tbody>
          <tr *ngFor="let eut of cleanEUTsArray">
            <td>{{getModuleName(eut)}} | {{eut.eName}}</td>
          </tr>
        </tbody>
      </table>
      <div class="row"></div>
      <table class="tableBackgrdClrBlack menuItemsClrWhite">
        <th>
          <tr>
            <td>
              <h6>&nbsp;{{ 'cockpitReport.dirtyEUT' | translate }}</h6>
            </td>
          </tr>
        </th>
        <tbody>
          <tr *ngFor="let eut of notCleanEUTsArray">
            <td>{{getModuleName(eut)}} | {{eut.eName}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row" *ngIf="cockpitName == 'outcomes'" id="sourceData">
    <div class="col-md-12">
      <table class="tableBackgrdClrBlack menuItemsClrWhite">
        <th>
          <tr>
            <td>
              <h6>&nbsp;{{ 'cockpitReport.cleanAttri' | translate }}</h6>
            </td>
          </tr>
        </th>
        <tbody>
          <tr *ngFor="let name of cleanAttriArray">
            <td>&nbsp;{{name.name}}</td>
          </tr>
        </tbody>
      </table>
      <div class="row"></div>
      <table class="tableBackgrdClrBlack menuItemsClrWhite">
        <th>
          <tr>
            <td>
              <h6>&nbsp;{{ 'cockpitReport.dirtyAttri' | translate }}</h6>
            </td>
          </tr>
        </th>
        <tbody>
          <tr *ngFor="let name of notCleanAttriArray">
            <td>&nbsp;{{name.name}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row" *ngIf="cockpitName == 'evaluation'" id="sourceData">
    <div class="col-md-12">
      <table class="tableBackgrdClrBlack menuItemsClrWhite">
        <th>
          <tr>
            <td>
              <h6>&nbsp;{{ 'cockpitReport.evalvatedEuts' | translate }}</h6>
            </td>
          </tr>
        </th>
        <tbody>
          <tr *ngFor="let eut of evalEUTsArray">
            <td>{{getModuleName(eut)}} | {{eut.eName}}</td>
          </tr>
        </tbody>
      </table>
      <div class="row"></div>
      <table class="tableBackgrdClrBlack menuItemsClrWhite">
        <th>
          <tr>
            <td>
              <h6>&nbsp;{{ 'cockpitReport.notevalvatedEuts' | translate }}</h6>
            </td>
          </tr>
        </th>
        <tbody>
          <tr *ngFor="let eut of notEvalEUTsArray">
            <td>{{getModuleName(eut)}} | {{eut.eName}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row" *ngIf="cockpitName == 'evaluation'" id="sourceData">
    <div class="col-md-12">
      <table class="tableBackgrdClrBlack menuItemsClrWhite">
        <th>
          <tr>
            <td>
              <h6>&nbsp;{{ 'cockpitReport.evalvatedAttributes' | translate }}</h6>
            </td>
          </tr>
        </th>
        <tbody>
          <tr *ngFor="let name of evalAttriArray">
            <td>&nbsp;{{name.name}}</td>
          </tr>
        </tbody>
      </table>
      <div class="row"></div>
      <table class="tableBackgrdClrBlack menuItemsClrWhite">
        <th>
          <tr>
            <td>
              <h6>&nbsp;{{ 'cockpitReport.notevalvatedAttributes' | translate }}</h6>
            </td>
          </tr>
        </th>
        <tbody>
          <tr *ngFor="let name of notEvalAttriArray">
            <td>&nbsp;{{name.name}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <footer>
    <p class="copyright">{{ 'cockpitReport.generatedBy' | translate }} {{userName}} {{ 'cockpitReport.on' | translate }}
      {{currentDate | date:'medium' }}&nbsp;&nbsp; [ doSmartQA ]</p>
  </footer>
</div>